import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface FAQItem {
  question: string;
  answer: string;
}

export default function FAQ() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqItems: FAQItem[] = [
    { question: t('faq_q1'), answer: t('faq_a1') },
    { question: t('faq_q2'), answer: t('faq_a2') },
    { question: t('faq_q3'), answer: t('faq_a3') },
    { question: t('faq_q4'), answer: t('faq_a4') },
    { question: t('faq_q5'), answer: t('faq_a5') },
    { question: t('faq_q6'), answer: t('faq_a6') },
    { question: t('faq_q7'), answer: t('faq_a7') },
    { question: t('faq_q8'), answer: t('faq_a8') },
  ];

  return (
    <div className="w-full max-w-3xl mx-auto">
      <div className="space-y-3">
        {faqItems.map((item, index) => (
          <div
            key={index}
            className="border border-gray-100 rounded-lg bg-white overflow-hidden"
          >
            <button
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
              className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-gray-50 transition-colors"
            >
              <span className="text-sm font-medium text-gray-900 pr-4">{item.question}</span>
              <i
                className={`ri-add-line text-emerald-600 flex-shrink-0 w-5 h-5 flex items-center justify-center transition-transform ${
                  openIndex === index ? 'rotate-45' : ''
                }`}
              />
            </button>
            {openIndex === index && (
              <div className="px-5 pb-4">
                <p className="text-sm text-gray-500 leading-relaxed">{item.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}